var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerGameTypeZoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.804 12.95l-2.256 1.646h8l-1.339 2.654H2.25l6.04-4.41 4.514.11zM13.922 12.133l-.66.482-4.668.003.67-.49 4.658.005zM14.433 11.76l-4.82.114 3.383-2.47H5.663L9.157 6.75h12.137l-6.86 5.01z",
    fill: "currentColor"
  })));
}
SvgPokerGameTypeZoom.displayName = 'PokerGameTypeZoom';
export default SvgPokerGameTypeZoom;